import { render } from "./FormSubmitButton.vue?vue&type=template&id=5946473c"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/form/FormSubmitButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5946473c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5946473c', __exports__)) {
    api.reload('5946473c', __exports__)
  }
  
  module.hot.accept("./FormSubmitButton.vue?vue&type=template&id=5946473c", () => {
    api.rerender('5946473c', render)
  })

}


export default __exports__